<template>
  <div>    
    <div class="container">
      <router-view />
    </div>
  </div>
</template>
<script>


export default {
  data() {
    return {
      message: "Login layout"
    };
  }
};
</script>


// WEBPACK FOOTER //
// src/components/layouts/Login.vue